//import TextBookManageWordPopup from "@/pages/comp/book_order/textbook/popup/manage_word";
import TextBookManageWordPopupArea from "@/pages/comp/book_order/textbook/common/popup/manage_word";

function TextBookManageWordPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    g_par_id: "",
    g_par_seq: "",
    ...props
  };

  return (
    <div>
      <TextBookManageWordPopupArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        g_par_id={myProps.g_par_id}
        g_par_seq={myProps.g_par_seq}
      ></TextBookManageWordPopupArea>
    </div>
  );
};
export default TextBookManageWordPopup;